import styled from "styled-components";
import { KnobContainer } from "../Knob/styles";

export const FXKnobContainer = styled(KnobContainer)`
  width: 28px;
  height: 28px;
  transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
`;
